module.exports = __webpack_public_path__ + "static/media/Gombeatta 28-6-2018.7732c4ec.jpg";